import {
  Controller,
  type FieldPath,
  type FieldValues,
  useFormContext,
} from 'react-hook-form';

import {
  type OptixTextFieldHookRenderProps,
  OptixAutocompleteHookRender,
} from './OptixAutocompleteHookRender';
import {type OmittedControllerProps} from '../../formTypes';

/** Add all the types together that we would want to provide externally */
export type OptixTextFieldHookProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = OmittedControllerProps<TFieldValues, TName> & OptixTextFieldHookRenderProps;

export function OptixAutocompleteHook<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  rules,
  shouldUnregister,
  defaultValue,
  name,
  ...autocompleteProps
}: OptixTextFieldHookProps<TFieldValues, TName>): JSX.Element {
  const {control} = useFormContext<TFieldValues>();
  return (
    <Controller<TFieldValues, TName>
      render={(controllerRenderParams) => (
        <OptixAutocompleteHookRender<TFieldValues, TName>
          {...autocompleteProps}
          {...controllerRenderParams}
        />
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      shouldUnregister={shouldUnregister}
    />
  );
}
